import React, { ReactNode } from "react";
import { ThemeProvider } from 'styled-components';
import { I18nextProvider } from 'react-i18next';
import { breakpoints } from "@utils/variables";
import i18n from '@components/i18n';
import { motion } from "framer-motion";
import tw from "twin.macro";

import '@styles/tailwind.css';
import '@styles/main.scss';
import '@components/i18n';

import Header from '@components/header';
import Footer from '@components/footer';
import CaseBackground from "@components/cases/background";
import CaseIntro from "@components/cases/into";
import CaseTestimonial from "@components/cases/testimonial/index";
import CaseNext from "@components/cases/next-case";
import CTA from "@components/cta";

type LayoutProps = {
  children: ReactNode,
  name: string,
  width: number,
  scroll: any
};

const OverflowHidden = tw.div`overflow-x-hidden`;

const Container = tw.div`container mx-auto xxl:max-w-1280!`;

const LayoutPortfolio = ({ children, name, width, scroll }: LayoutProps) => {
  return (
    <I18nextProvider i18n={ i18n }>
      <ThemeProvider theme={{ breakpoints }}>
        <Header isPortfolioCasePage />
        <CaseBackground width={width} name={name} />
        <OverflowHidden>
          <Container>
            <main>
              <CaseIntro width={width} name={name} />
              <motion.div
                className="lg:opacity-0"
                animate={ width >= 1024 && { opacity: 1 }}
                transition={{
                  duration: .6,
                  delay: 1.2,
                  ease: [0.13, -0.22, 1, 1.02]
                }}
              >
                {children}
              </motion.div>
              <CaseTestimonial width={width} scroll={scroll} name={name} />
              <CaseNext width={width} scroll={scroll} name={name} />
              <CTA width={width} scroll={scroll} />
            </main>
            <Footer />
          </Container>
        </OverflowHidden>
      </ThemeProvider>
    </I18nextProvider>
  );
};

export default LayoutPortfolio;
